/* unplugin-vue-components disabled */import { render } from "./GoodRight.vue?vue&type=template&id=6f809fed&ts=true"
import script from "./GoodRight.vue?vue&type=script&lang=ts"
export * from "./GoodRight.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__